import React, { useMemo } from 'react';
import { Platform, Text } from 'react-native';
import { format, parseISO } from 'date-fns';
import { Colors } from '@/constants/blog-colors';

interface TitleProps {
  slug?: string;
  children: React.ReactNode;
  date: string;
  basePath?: string;
}

export const Title: React.FC<TitleProps> = React.memo(
  ({ children, date: dateString }) => {
    // Format date
    const dateFormatted = useMemo(
      () => format(parseISO(dateString), 'EEEE, MMMM d, yyyy'),
      [dateString]
    );

    return (
      <div className="flex flex-col gap-2 mb-5">
        {Platform.OS !== 'ios' && <TitleText>{children}</TitleText>}
        <DateDisplay date={dateFormatted} />
      </div>
    );
  }
);

const TitleText: React.FC<{ children: React.ReactNode }> = React.memo(
  ({ children }) => {
    return (
      <h1
        style={{
          fontSize: '1.25rem',
          display: 'block',
          fontFamily: 'var(--font-inter)',
          marginBottom: '0.5em',
          lineHeight: '1.3333333',
          color: Colors.h1,
          fontWeight: '600',
        }}
        className="mt-8 md:mt-36 mb-1 md:mb-2 text-subtle"
      >
        {children}
      </h1>
    );
  }
);

const DateDisplay: React.FC<{ date: string }> = React.memo(({ date }) => {
  return (
    <div className="flex items-center flex-row gap-2">
      <Text
        style={{
          fontSize: '0.8rem' as any,
          color: '#bbbbbb',
          fontFamily: 'var(--font-inter)',
        }}
      >
        {date}
      </Text>
    </div>
  );
});
